// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '@vant/touch-emulator'
import axios from 'axios'
import VueAxios from 'vue-axios'
import qs from 'qs'

import store from './store'//引入Vuex

import FloatTools from './components/FloatTools'

import '@/../static/css/style.css'
import Site from './site.js'

import md5 from 'js-md5';
// 引入阿里图标
import "../static/fonts/iconfont/iconfont.css";
import {
  Calendar,
  Card,
  Tag,
  Checkbox, CheckboxGroup,
  RadioGroup, Radio,
  Image,
  Lazyload,
  Swipe, SwipeItem,
  Sticky,
  Grid, GridItem,
  Stepper,
  SubmitBar,
  Dialog,
  Popup,
  Form,
  DropdownMenu, DropdownItem,
  Field,
  ActionSheet,
  List,
  Toast,
  Collapse, CollapseItem,
  Tab, Tabs,
  Switch,
  Picker,
  Loading,
  Steps,
  Step,
  DatetimePicker,
  Area,
  Button,
  NavBar,
  Cell,
  CellGroup,
  Icon,
  Search
} from 'vant'

Vue.use(Button)
  .use(Cell).use(CellGroup)
  .use(Calendar)
  .use(Icon)
  .use(Checkbox).use(CheckboxGroup)
  .use(Radio).use(RadioGroup)
  .use(Card)
  .use(Tag)
  .use(Image)
  .use(Lazyload)
  .use(Swipe).use(SwipeItem)
  .use(NavBar)
  .use(Sticky)
  .use(Grid).use(GridItem)
  .use(Stepper)
  .use(SubmitBar)
  .use(Dialog)
  .use(Popup)
  .use(Form)
  .use(DropdownMenu).use(DropdownItem)
  .use(Field)
  .use(ActionSheet)
  .use(List)
  .use(Toast)
  .use(Collapse).use(CollapseItem)
  .use(Tab).use(Tabs)
  .use(Picker)
  //.use(Site)
  .use(Switch)
  .use(Loading)
  .use(Steps)
  .use(Step)
  .use(DatetimePicker)
  .use(Search)
  .use(Area);

Vue.use(VueAxios, axios);

Vue.use(Site);
Vue.use(FloatTools);

//注册自定义组件
Vue.component('FloatTools', FloatTools)

Vue.prototype.qs = qs;

Vue.prototype.$md5 = md5;
import SvgIcon from './components/SvgIcon'; // svg component

// register globally
Vue.component('svg-icon', SvgIcon);

// const requireAll = requireContext => requireContext.keys().map(requireContext);
// const req = require.context('./icons', false, /\.svg$/);
// requireAll(req);
//======= 路由守卫
router.beforeEach((to, from, next) => {
  //alert(to.path);
  //https://xxx/#/sso/?token=1111&return_url=222
  if( to.path === '/sso' ){
    next();
  } else if( to.path === '/sorry' ){
    next();
  }

  //判断当前页是否需要登录
  if( to.meta.requireLogin ){
    //获取到已登录的用户信息
     let loginuser_data = JSON.parse(localStorage.getItem('giant_userdata'));

    if( loginuser_data ){// && loginuser_data.token
      //Vue.prototype.GLOBAL.loginUser = loginuser_data;
      store.commit('updateLoginUser', loginuser_data);
      //console.log(loginuser_data);
    } else {
      //router.replace({ path: '/login',query: { redirect: to.fullPath }})
      router.replace({ path: '/sorry' ,query: {redirect: location.href}});
    }

    next();
  } else {
    next();
  }

});

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js